import {defineStore} from 'pinia'
import {ref} from 'vue'

export const useHeaderStore = defineStore('header', () => {
  const showBack = ref(false)
  const backAction = ref<(() => void) | null>(null)

  function triggerBack(): void {
    backAction.value?.()
  }

  return {showBack, backAction, triggerBack}
})
